import { Skeleton } from "@mui/material";

interface Props {}

export default function ClientOrderReportPageSkeletonUI(props: Props) {
	return (
		<div>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					gap: "10px",
					flexWrap: "wrap",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "5px",
						width: "50%",
					}}
				>
					<div>
						<Skeleton
							variant="rectangular"
							width={"30%"}
							height={20}
							sx={{ borderRadius: "4px", minWidth: "150px" }}
						/>
					</div>

					<div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
						<Skeleton
							variant="rectangular"
							width={"50%"}
							height={40}
							sx={{ borderRadius: "4px", minWidth: "200px" }}
						/>
					</div>
				</div>
			</div>
			<div
				style={{
					margin: "60px auto",
					width: "70%",
					maxWidth: "900px",
					display: "flex",
					flexDirection: "column",
					gap: "15px",
				}}
			>
				<div>
					<div style={{ marginBottom: "10px" }}>
						<Skeleton
							variant="rectangular"
							width={"40%"}
							height={24}
							sx={{ borderRadius: "4px" }}
						/>
					</div>
					<div className="test-report-card-radio-group">
						<Skeleton
							variant="rectangular"
							width={"100%"}
							height={140}
							sx={{ borderRadius: "14px" }}
						/>
						<Skeleton
							variant="rectangular"
							width={"100%"}
							height={140}
							sx={{ borderRadius: "14px" }}
						/>{" "}
						<Skeleton
							variant="rectangular"
							width={"100%"}
							height={140}
							sx={{ borderRadius: "14px" }}
						/>
					</div>
				</div>
				<Skeleton
					variant="rectangular"
					width={"100%"}
					height={300}
					sx={{ borderRadius: "14px" }}
				/>
			</div>
		</div>
	);
}
